import { useState, useEffect } from "react";
import activeListeningImg from "@assets/Active_Listening_dashboard_1784064450488.webp";
import rapidDeployImg from "@assets/Rapid_deploy_dashboard_1784133541960.webp";

const dashboards = [
  {
    src: activeListeningImg,
    alt: "HarmCheck Active Listening dashboard showing team-wide communication risk: 6 unlawful flags, 98 harmful flags, 127 total flags across 241 employees, with a ranked list of members and their flagged communications",
  },
  {
    src: rapidDeployImg,
    alt: "HarmCheck Rapid Deploy dashboard showing the evidence in your data: 1.3M sentences analyzed and 205.8K findings, with a list of review cases and their finding counts",
  },
];

export function DashboardPreview() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % dashboards.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="py-24 bg-background border-b border-border/40">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-16 items-start">
          <div className="lg:w-1/2 flex flex-col gap-10 text-center md:text-left">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-3">
                A Complete View of Your Communication Risk
              </h2>
              <p className="text-[22px] md:text-[24px] text-primary-text leading-tight md:leading-relaxed font-semibold mb-4">
                Communication Compliance Dashboard
              </p>
              <p className="text-muted-foreground max-w-xl mx-auto md:mx-0 text-lg leading-relaxed">
                Whether you use Active Listening, Rapid Deploy, or both—HarmCheck gives you a complete view.<br /><br />Active Listening shows real-time communication health, giving compliance managers instant visibility into risk as it emerges. Rapid Deploy brings clarity to large-scale datasets as they’re processed.
              </p>
            </div>
          </div>

          <div className="lg:w-1/2 z-10 w-full">
            <div className="relative border border-border/50 bg-white shadow-2xl overflow-hidden aspect-[1600/968]">
              {dashboards.map((d, i) => (
                <img
                  key={i}
                  src={d.src}
                  alt={activeIndex === i ? d.alt : ""}
                  width="1600"
                  height="968"
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  style={{
                    opacity: activeIndex === i ? 1 : 0,
                    transition: "opacity 1000ms ease",
                  }}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
